<template>
  <section class="flex margin-top-s column">
    <!-- filters -->
    <div class="flex-1 flex column w100 middle">
      <div class="flex-1 w100">
        <div class="flex end filters-group-holder between">
          <div style="margin-right: 16px;" class="flex column no-mobile">
            <label>Atualizar</label>
            <div class="flex end w100" style="margin-top:12px">
              <div @click="forceRefreshData()" class="button secondary">
                <i class="fas fa-sync-alt"></i>
              </div>
            </div>
          </div>
          <div style="margin-right: 16px;" class="flex column no-mobile">
            <label>Exportar</label>
            <div class="flex end w100" style="margin-top:12px">
              <div @click="exportData()" class="button secondary">
                <i class="fas fa-download"></i>
              </div>
            </div>
          </div>

          <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
        </div>
      </div>
    </div>

    
    <!-- group by sale -->
    <div class="box flex-1 w100 margin-top-l  no-mobile">
      <div class="flex box-title middle">
        <div class="flex-1">
          <h4>
            Explorador de UTMS
          </h4>
        </div>
        <div class="flex end filters-group-holder between">
          <div class="filter-item">
            <label>Buscar</label>
            <div class="flex w100">
              <input class="input" type="text" v-model="filters.data.search" />
            </div>
          </div>
          <div class="filter-item">
            <label>Agrupar por</label>
            <select class="input" v-model="filters.data.group_by">
              <option
                v-for="(c, index) in filters.list.group_by"
                :key="index"
                :value="c.value"
                :selected="c.value === filters.data.group_by"
              >
                {{ c.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="box-content">
        <ul>
          <li class="header">
            <div class="flex middle row">
              <div class="flex-1">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    {{ filters.data.group_by }}
                  </div>
                  <div class="flex-1">
                    <div class="flex details between">
                      <div class="flex-1 txt-center">
                        <p>Vendas</p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p>Receita Bruta</p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p>Receita Líquida</p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p>Marketing</p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p>Roas</p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p>Lucratividade</p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p>Lucro</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li v-for="(track, index) in trackings" :key="index">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name margin-top-s">
                    <p>
                      {{ track.name | protect }}
                    </p>
                  </div>
                  <div class="flex-1 margin-top-s">
                    <div class="flex details between">
                      <div class="flex-1 txt-center">
                        {{ track.stats.sales_all | number }}
                      </div>
                      <div class="flex-1 txt-center">
                        <small
                          >{{ track.stats.receita_bruta | money }} ({{
                            track.stats.sales_all | number
                          }})</small
                        >
                      </div>
                      <div class="flex-1 txt-center">
                        <small
                          >{{ track.stats.approved_sales_sum | money }} ({{
                            track.stats.sales | number
                          }})</small
                        >
                      </div>
                      <div class="flex-1 txt-center">
                        <small
                          >{{ track.stats.spend | money }}
                          </small
                        >
                      </div>
                      <div class="flex-1 txt-center">
                        <small class="tag" :class="{ negative: track.stats.roas <= 1, positive: track.stats.roas > 1 }"
                          >{{ track.stats.roas | number }}x</small
                        >
                      </div>
                      <div class="flex-1 txt-center">
                        <small  class="tag" :class="{ negative: track.stats.profit <= 0, positive: track.stats.profit > 0 }"
                          >{{ track.stats.profit | number }}%</small
                        >
                      </div>
                      <div class="flex-1 txt-center">
                        <small  class="tag" :class="{ negative: track.stats.profit_value <= 0, positive: track.stats.profit_value > 0 }"
                          >{{ track.stats.profit_value | money }}</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="false" class="action">
                <div class="flex end">
                  <router-link
                    :to="{
                      name: 'ProductDetail',
                      params: { product_id: product.id },
                    }"
                  >
                    <div class="button primary">Relatório</div>
                  </router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div v-if="isEmpty" class="center-text">
          <div class="margin-top-l">
            <p>
              Não encontramos nenhuma origem de venda. Assim que você tiver a
              primeira venda a origem vai aparecer nessa lista de forma
              automática!
            </p>
          </div>
        </div>

        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>

        <!-- pagination -->
        <div class="flex-1 flex row w100 middle margin-top-l">
          <div class="flex w100 center filters-groupo-holder">
            <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { getTrackings } from "@/services/tracking.js";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

export default {
  name: "source-sale",
  components: {
    ltkDatePicker,
  },
  data() {
    return {
      loading: false,
      filters: {
        data: {
          date: [
            moment()
              .add(-30, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          group_by: "utm_campaign",
          search: "",
        },
        list: {
          group_by: [
            {
              value: "utm_campaign",
              label: "utm_campaign",
            },
            {
              value: "utm_source",
              label: "utm_source",
            },
            {
              value: "utm_medium",
              label: "utm_medium",
            },
            {
              value: "utm_content",
              label: "utm_content",
            },
            {
              value: "utm_term",
              label: "utm_term",
            },
            {
              value: "sck",
              label: "sck",
            },
            {
              value: "src",
              label: "src",
            },
          ],
        },
      },
      UTMS: {
        utm_campaign: [],
        utm_medium: [],
        utm_source: [],
        utm_content: [],
        utm_term: [],
        src: [],
        sck: [],
      },
      trackings: [],
      totalTracking: 0,
      stats: {
        sales: 0,
        receita_bruta: 0,
        receita_liquida: 0,
      },
      offset: 10,
      page: 1,
      refreshTime: 60,
      refreshInterval: null,
    };
  },
  mounted() {
    this.getTrackings();
    this.refreshInterval = setInterval(
      this.getTrackings,
      this.refreshTime * 1000
    );
  },
  destroyed() {
    clearInterval(this.refreshInterval);
  },
  computed: {
    isEmpty() {
      // return !this.loading && this.Trackings && this.Trackings.length === 0;
      return this.totalTracking === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalTracking % this.offset;
      let value = this.totalTracking / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.trackings = [];
        this.getTrackings();
      },
    },
    page: {
      handler() {
        this.trackings = [];
        this.getTrackings();
      },
    },
  },
  methods: {
    fn(n) {
      if (!n) return n
      return n.toFixed(2)
    },
    forceRefreshData() {
      this.getTrackings();
    },
    getTrackings() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        group_by: this.filters.data.group_by,
        search: this.filters.data.search,
        page: this.page,
        offset: this.offset,
      };
      getTrackings(params)
        .then((result) => {
          this.trackings = result.trackings.map((p) => {
            return {
              name: p.name,
              group_by: p.group_by,
              stats: {
                sales: p.stats.sales,
                approved_sales_sum: p.stats.approved_sales_sum,
                receita_bruta: p.stats.receita_bruta,
                sales_all: p.stats.sales_all,
                profit: p.stats.profit,
                roas: p.stats.roas,
                profit_value: p.stats.profit_value,
                spend: p.stats.spend,
              },
            };
          });

          // utms
          this.UTMS = result.utms;

          this.totalTracking = result.total;

          this.stats = result.stats;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar tracking",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportData() {
      let dataRaw = "CAMPANHA,TOTAL,TOTAL_PAGO,SUM_TOTAL,SUM_PAGO";
      let dataRows = [dataRaw];

      this.trackings.forEach((row) => {
        let auxLine = `${row.name},${row.stats.sales_all},${row.stats.sales},${row.stats.receita_bruta},${row.stats.approved_sales_sum}`;
        dataRows.push(auxLine);
      });

      dataRows = dataRows.join("\n");

      var fileURL = window.URL.createObjectURL(new Blob([dataRows]));
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "exportacao-tabela-tracking.csv");
      document.body.appendChild(fileLink);
      fileLink.click();

      this.$toast.success({
        title: "Sucesso",
        message: "Exportação gerada com sucesso",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.name {
  max-width: 500px;
  display: inline-block;
  line-break: anywhere;
}

li {
  list-style-type: none;
  padding-bottom: 8px;
  padding-top: 8px;
  border-bottom: 1px solid #e6e4e4;
  padding-left: 8px;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

.pagination {
  margin: 0px !important;
}
.box-primary {
  background: var(--primary);
  color: #fff;
}

.header {
  // margin-bottom: 18px;
  font-size: 14px;
  font-weight: 800;
  background: var(--primary);
  color: #fff;
  padding: 8px 8px;
  border-radius: 4px;
}

grid-flex .box + .box,
.flex .box + .box {
  margin-left: 0px;
}

.graphs {
  .graph {
    max-width: 100%;
    max-height: 300px;
  }
}

.tag {
  background: #22222212;
  padding: 4px 8px;
  border-radius: 8px;
}

.negative {
  color: red;
}
.positive {
  color: green
}

@media screen and (max-width: 1024px) {
  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ":";
      }
      small {
        margin-left: 8px;
      }
    }
  }
  .action {
    margin-top: 16px;
  }
}
</style>
